(function () {
  'use strict';

  angular.module('app').component('saleChannelList', saleChannelList());

  function saleChannelList() {
    return {
      bindings: {
        saleChannels: '=',
        loadingItems: '<',
        onShowSaleChannel: '&',
      },
      controller: SaleChannelListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/sale-channels/sale-channel-list/sale-channel-list.component.html',
    };
  }

  SaleChannelListComponent.$inject = [
    'UtilService',
    'AbilityService',
    'SaleChannelService',

    // Angular downgraded service
    'userModalService',
  ];

  function SaleChannelListComponent(
    UtilService,
    AbilityService,
    SaleChannelService,

    // Angular downgraded service
    userModalService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_salechannel_accountadmin'),
      canShow: AbilityService.can('show_salechannel_accountadmin'),
      canUpdate: AbilityService.can('update_salechannel_accountadmin'),
      canDestroy: AbilityService.can('destroy_salechannel_accountadmin'),
    };

    // public methods
    // -----------------------
    vm.showSaleChannel = function (saleChannel, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowSaleChannel({ item: saleChannel, mode: mode });
    };

    vm.changeSaleChannelStatus = function (saleChannel) {
      SaleChannelService.changeSaleChannelStatus(saleChannel);
    };

    vm.setDefaultSaleChannel = function (saleChannel) {
      const successCallback = function () {
        vm.saleChannels.forEach(function (item) {
          if (item.id !== saleChannel.id) {
            item.is_default_channel = false;
          }
        });
      };

      SaleChannelService.setDefaultSaleChannel(saleChannel, successCallback);
    };

    vm.setDefaultSaleSource = function (saleChannel) {
      const successCallback = function () {
        vm.saleChannels.forEach(function (item) {
          if (item.id !== saleChannel.id) {
            item.is_default_source = false;
          }
        });
      };

      SaleChannelService.setDefaultSaleSource(saleChannel, successCallback);
    };

    vm.deleteSaleChannel = function (saleChannel, index) {
      const successCallback = function (index) {
        vm.saleChannels.splice(index, 1);

        vm.totalItems = vm.saleChannels.length;
      };

      SaleChannelService.deleteSaleChannel(saleChannel, successCallback, index);
    };

    vm.openUserInfoModal = function (user) {
      userModalService.openUserInfoModal(user);
    };
  }
})();
